/**
 * Where media (tiles, thumbnails, the JSON index files) is fetched from.
 *
 * Stored paths stay relative — `/media/xl67Gd/thumb.jpg` — and the origin is
 * resolved here at request time. That way moving from the dev proxy to S3 to
 * CloudFront is a config change, not a rewrite of every JSON file already
 * sitting in the bucket.
 *
 * Empty (the default) means same-origin: the dev server proxies /media, and in
 * production CloudFront serves it from the same domain as the app.
 */
const BASE = (import.meta.env.VITE_MEDIA_BASE ?? '').replace(/\/+$/, '')

/** Absolute URL for a stored media path. */
export function mediaUrl(path: string): string {
  if (!BASE) return path
  return `${BASE}${path.startsWith('/') ? '' : '/'}${path}`
}

/**
 * True when media comes from another origin, which is the case when pointing
 * straight at an S3 bucket. Tiles then need `crossOrigin` set, because WebGL
 * refuses to upload a cross-origin image that wasn't fetched with CORS.
 */
export const MEDIA_IS_CROSS_ORIGIN =
  BASE !== '' && !BASE.startsWith(globalThis.location?.origin ?? ' ')
